var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 27,
    viewBox: "0 0 18 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    title: "person",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.00146,
    cy: 5.3999,
    r: 4.3999,
    fill: "white",
    stroke: "#285FCB",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9997 21.2869C16.9997 22.2737 16.7827 22.9733 16.4519 23.4867C16.121 24 15.6273 24.4031 14.9468 24.7153C13.5357 25.3625 11.4845 25.5496 8.99983 25.5496C6.51517 25.5496 4.46401 25.3625 3.05289 24.7153C2.3724 24.4031 1.87864 24 1.5478 23.4867C1.21693 22.9733 1 22.2737 1 21.2869C1 17.3715 4.49645 14.0498 8.99983 14.0498C13.5032 14.0498 16.9997 17.3715 16.9997 21.2869Z",
    fill: "white",
    stroke: "#285FCB",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.46d424bc.svg";
export { ForwardRef as ReactComponent };